function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M-0.187487 26.2106C4.64678 19.6307 10.7297 14.0674 17.714 9.83831C24.6983 5.60924 32.4472 2.79724 40.5183 1.56286C48.5893 0.328488 56.8245 0.695911 64.7536 2.64416C72.6826 4.59241 80.1503 8.08332 86.7302 12.9176L49.9179 63.023L-0.187487 26.2106Z",
  fill: "black"
}), React.createElement("path", {
  d: "M49.9182 63.0231C56.4981 67.8574 63.9658 71.3483 71.8949 73.2965C79.8239 75.2448 88.0591 75.6122 96.1301 74.3778C104.201 73.1435 111.95 70.3315 118.934 66.1024C125.919 61.8733 132.002 56.31 136.836 49.7301L86.7305 12.9177L49.9182 63.0231Z",
  fill: "#1C53E7"
}), React.createElement("circle", {
  cx: 68.0361,
  cy: 38.0147,
  r: 15.5437,
  transform: "rotate(-143.695 68.0361 38.0147)",
  fill: "#F8D748"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 137,
  height: 77,
  fill: "white"
})));

var SvgCoverageDetailShape = function SvgCoverageDetailShape(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 137,
    height: 77,
    viewBox: "0 0 137 77",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoverageDetailShape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coverage-detail-shape.d78b9ea6.svg";
export { ForwardRef as ReactComponent };